@if (!universalService.isMobileDevice) {
  <div class="modal fade" id="delete-modal" role="dialog" aria-labelledby="delete-modal" tabindex="-1" aria-hidden="true" [ngStyle]="{'display': showDeleteModal ? 'block' : 'none','opacity': 1, 'background' : 'rgba(0,0,0,0.5)','backdrop-filter':'blur(10px)', 'transition':'all ease-in .1s'}">
    <div class="modal-dialog modal-dialog-centered modal-md" role="document">
      <div class="modal-content h-90">
        <div class="modal-header">
          <button type="button" tabindex="-1" class="close btn-pos" data-dismiss="modal" (click)="closePopUp()">
            <span class="NeueFile_Cancel"></span>
            <span class="esc">esc</span>
          </button>
          @if (currentRoute != 'sharedwithme' && universalService.currentTab != 'PrivateFolder' && universalService.currentTab != 'Album Details' && universalService.currentTab != "DigiLocker") {
            <h5 class="mb-0">Delete</h5>
          }
          @if (universalService.currentTab == 'PrivateFolder' || universalService.currentTab == "DigiLocker") {
            <h5 class="mb-0">Delete file(s)?</h5>
          }
          @if (currentRoute == 'sharedwithme') {
            <h5 class="mb-0">Remove</h5>
          }
          @if (universalService.currentTab == 'Album Details') {
            <h5 class="mb-0">Remove from Album?</h5>
          }
        </div>
        <div class="modal-body border-bottom-0">
          <div class="delete-confimration mt-3">
            @if (currentRoute != 'sharedwithme') {
              <ul>
                @if (universalService.currentTab == 'PrivateFolder') {
                  <li class="text">Files/Folders you delete from the "Private Folder" are permanently deleted</li>
                }
                @if (universalService.currentTab != 'PrivateFolder' && universalService.currentTab != 'DigiLocker' && universalService.currentTab != 'Album Details' && filesNotOwnedByUser.length == 0) {
                  <li class="text">Are you sure you want to delete {{universalService.selectedNodes.length}} item(s)?</li>
                }
                @if (universalService.currentTab != 'PrivateFolder' && universalService.currentTab != 'DigiLocker' && universalService.selectedTab != 'Album Details') {
                  <li class="subtext"> Deleted items can be retrieved from Trash.</li>
                }
                @if (universalService.currentTab == 'DigiLocker') {
                  <li class="text">Files deleted from this folder will be permanently removed and cannot be recovered. Are you sure you want to proceed?</li>
                }
                @if (universalService.selectedTab == 'Album Details' && filesNotOwnedByUser.length == 0) {
                  <li class="subtext"> Are you sure you want to remove <span> {{(universalService.selectedNodes.length > 1? universalService.selectedNodes.length+ " item(s)" : '"'+universalService.selectedFile?.objectShortName+'"')}} </span>  from Album?</li>
                }
                @if (universalService.selectedTab == 'Album Details' && filesNotOwnedByUser.length == 0) {
                  <li class="subtext"> You cannot undo this action.</li>
                }
                @if (universalService.selectedTab == 'Album Details' && filesNotOwnedByUser.length>=1) {
                  <li class="text"> 1 or more files selected, belong to other members which cannot be deleted by you.</li>
                }
              </ul>
            }
            @if (currentRoute == 'sharedwithme') {
              <ul>
                <li class="text">Are you sure you want to remove {{universalService.selectedNodes.length}} item(s)?</li>
                <li class="subtext removeText"> Depending on your role, corresponding action will be taken on the file.</li>
              </ul>
            }
          </div>
        </div>
        <div class="modal-footer border-top-0 p-3">
          <div class="delete-btn-main">
            @if (currentRoute != 'sharedwithme' && universalService.currentTab != 'Album Details') {
              <button (click)="deleteItem()">Delete</button>
            }
            @if (currentRoute == 'sharedwithme' || universalService.currentTab == 'Album Details') {
              <button (click)="deleteItem()">Remove</button>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
}




@if (universalService.isMobileDevice) {
  <div class="modal fade slide-in-fwd-center" id="m-delete-modal" data-backdrop="false" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true" [ngStyle]="{'display': universalService.popUpToBeOpened == 'deletePopUp' ? 'block' : 'none', 'opacity': 1,'background' : 'rgba(0,0,0,0.5)','backdrop-filter':'blur(10px)', 'transition':'all ease-in .1s'}">
    <div class="modal-dialog" role="document">
      <div class="modal-content animated bounceInUp fixed-bottom">
        <div class="modal-header">
          @if (universalService.selectedTab != 'Album Details' && currentRoute != 'sharedwithme' && universalService.currentTab != 'sharedFiles') {
            <h6>Are you sure you want to delete {{universalService.selectedNodes.length}} file(s)? </h6>
          }
          @if (currentRoute != 'sharedwithme' && universalService.currentTab == 'sharedFiles') {
            <h6>Are you sure you want to delete {{universalService.selectedNodes.length}} file(s)? <br><br> The file/folder you are deleting will also be deleted from your My Files / All Files.</h6>
          }
          @if (currentRoute == 'sharedwithme') {
            <h6>Are you sure you want to remove {{universalService.selectedNodes.length}} file(s)?</h6>
          }
          @if (universalService.selectedTab == 'Album Details' && filesNotOwnedByUser.length == 0) {
            <h6> Are you sure you want to remove <span> {{(universalService.selectedNodes.length > 1? universalService.selectedNodes.length+ " item(s)" : '"'+universalService.selectedFile?.trimmedObjectName+'"')}} </span> from Album?</h6>
          }
          @if (universalService.selectedTab == 'Album Details' && filesNotOwnedByUser.length>=1) {
            <h6>1 or more files selected, belong to other members which cannot be deleted by you.</h6>
          }
        </div>
        <div class="modal-body">
          <div class="m-cancel-button">
            <button (click)="closePopUp()">CANCEL</button>
          </div>
          <div class="m-delete-button pt-3">
            @if (currentRoute != 'sharedwithme' && universalService.currentTab != 'Album Details') {
              <button (click)="deleteItem()">DELETE</button>
            }
            @if (currentRoute == 'sharedwithme' || universalService.currentTab == 'Album Details') {
              <button (click)="deleteItem()">REMOVE</button>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
}